/** @format */

import React, { useState } from 'react';

import { Form, Input, InputNumber, Button, Row, Col } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import serviceSearchProduct from '../../hooks/services/serviceSearchProduct';
import { serviceUpdatePrice, serviceUpdateStock } from './services';
import { GetLocalStorageValue } from '../../_config/utils/get-local-storage-value.util';
import { LOCAL_STORAGE } from '../../v2-config/constants/local-storage.constant';


import './style.css';

export default function StockV2(props) { //TODO REFACTOR

	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [searchList, setSearchList] = useState([]);
	const [product, setProduct] = useState({});
	const { pharmacy } = GetLocalStorageValue(LOCAL_STORAGE.USER);

	const handleSearchList = async ({ target: { value } }) => {
		const checkRepeat = (str) => {
			const repeats = /(.)\1/;
			return repeats.test(str);
		};
		const containsSpecialChars = (str) => {
			const specialChars = /\[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/; //eslint-disable-line
			return specialChars.test(str);
		};

		if (value?.length > 3 && value?.length % 2 === 0 && !checkRepeat(value) && !containsSpecialChars(value)) {
			let response = await serviceSearchProduct({ value, pharmacy });
			setSearchList(response);
		} else {
			setSearchList([]);
		}
	};



	const handleCleanList = (item) => {
		setProduct(item);
		form.setFieldsValue({
			price: item.price,
			stock: item.stock,
		});
		setSearchList([]);
	};

	const handleFinishUpdate = async (item) => {
		setLoading(true);
		if (item.stock !== product.stock) await serviceUpdateStock(item.stock, product.code_internal, pharmacy);
		if (item.price !== product.price) await serviceUpdatePrice(item.price, product.code_internal, pharmacy);
		setLoading(false);
	};



	return (
		<div className='stock-container'>
			<h1 className="ph-tracking-detail-global-title">Actualización de Stock & Precio</h1>
	
			<div className="ph-search-products-container">
				<Input
					type="text"
					onChange={handleSearchList}
					placeholder="Buscar productos..."
					className={`ph-search-header-input-windows ph-search-products`}
				/>
				{searchList.length > 0 && (
					<ul className="ph-search-products-list-main-container" style={{ display: 'block' }}>
						{searchList.map((item) => (
							<li className="ph-search-products-list" onClick={() => handleCleanList(item)} key={item.code_internal}>
								<div className="ph-search-products-list-description">
									<Row>
										<Col span={2} className="ph-search-header-images-search-content">
											<picture className="ph-search-products-list-image-container">
												<source className="ph-search-products-list-image" srcSet={`${item.image}`} type="image/webp" />
												<img
													className="ph-search-products-list-image"
													src={`${item.image}`}
													alt={item.editable_name}
													title={item.editable_name}
												/>
											</picture>
										</Col>
										<Col span={22} className="ph-search-header-titles-search-content">
											<h3 className="ph-search-header-titles-search-h3">{item.editable_name}</h3>
										</Col>
									</Row>
								</div>
							</li>
						))}
					</ul>
				)}
			</div>
			{'code_internal' in product && (
				<>
					<Row className="ph-stocks-product-container" align="middle">
						<Col>
							<picture>
								<source srcSet={`${product.image}`} type="image/webp" />
								<img
									className="ph-stocks-product-img"
									src={`${product.image}`}
									alt={product.editable_name}
									title={product.editable_name}
								/>
							</picture>
						</Col>
						<Col span={8}>
							<h3 className="ph-search-header-titles-search-h3">{product.editable_name}</h3>
						</Col>
						<Col>
							<b>{product.code_internal}</b>
						</Col>
					</Row>
					<Form form={form} onFinish={handleFinishUpdate}>
						<Row className="ph-stocks-form-container">
							<Col span={10}>
								<Form.Item label="Cantidad" name="stock" rules={[{ required: true, message: 'La cantidad de stock es requerida' }]}>
									<InputNumber min={0} placeholder="Cantidad" style={{ width: '95%' }} />
								</Form.Item>
							</Col>
							<Col span={10}>
								<Form.Item label="Precio" name="price" rules={[{ required: true, message: 'El precio es requerido' }]}>
									<InputNumber min={0} placeholder="precio" style={{ width: '95%' }} />
								</Form.Item>
							</Col>
						</Row>
						<Row className="ph-stocks-footer" align="middle">
							<Col span={2}>
								<Button type="primary" htmlType="submit" loading={loading}>
									Actualizar
								</Button>
							</Col>
							<Col className="ph-stocks-footer-warning">
								<QuestionCircleOutlined />
							</Col>
							<Col className="ph-stocks-footer-warning ph-stocks-footer-warning-text">
								¡Los cambios pueden tardar unos minutos en ser reflejados!
							</Col>
						</Row>
					</Form>
				</>
			)}
		</div>
	);
}
